import dayjs from 'dayjs'
import { AddressQuestionValue, FormQuestionValue } from '../../../../../../types/Forms'
import { FormLogicQuestionType } from './checkIfAnswerFulfillsRequirement'
import { getUsesUUIDs } from './constants'

export default (
  question: FormLogicQuestionType,
  questionAnswers: FormQuestionValue,
  questionLogic: string | number
) => {
  const usesUUIDs = getUsesUUIDs(question)

  if (usesUUIDs) {
    return questionAnswers?.__uuid === questionLogic?.toString()
  }

  if (question.questionType === 'DATE') {
    return dayjs(questionAnswers?.value as string).isSame(questionLogic)
  }

  if (question.questionType === 'ADDRESS') return (questionAnswers?.value as AddressQuestionValue).id === questionLogic

  return questionAnswers?.value === questionLogic
}
